import { I18n } from 'aws-amplify/utils';
import { translations } from '@aws-amplify/ui-react';

// For AWS amplify authorizatin module AWS i18n has to be used,
//  while rest of the applization uses i18nnext

export default function setupAmplifyI18n() {
    I18n.putVocabularies(translations);
}

/**
 * Sets the language for AWS Amplify UI i18n module
 * @param languageCode - The language code to set (e.g., 'en', 'cs')
 */
export function setAmplifyLanguage(languageCode: string): void {
    I18n.setLanguage(languageCode);
}

I18n.putVocabularies({
    cs: {
        'Account recovery requires verified contact information': 'Obnovení účtu vyžaduje ověřený kontakt',
        'Add your Profile': 'Přidej svůj Profil',
        'Add your Website': 'Přidej svůj Web',
        'Back to Sign In': 'Návrat k přihlášení',
        'Change Password': 'Změnit Heslo',
        Changing: 'Zpracování změny',
        Code: 'Kód',
        'Confirm Password': 'Potvrdit heslo',
        'Confirm Sign Up': 'Potvrdit vytvoření účtu',
        'Confirm SMS Code': 'Potvrdit SMS kód',
        'Confirm MFA Code': 'Potvrdit MFA kód',
        'Confirm TOTP Code': 'Potvrdit TOTP kód',
        Confirm: 'Potvrdit',
        'Confirmation Code': 'Potvrzovací kód',
        Confirming: 'Potvrzuji',
        'Create a new account': 'Vytvořit nový účet',
        'Create Account': 'Vytvořit účet',
        'Creating Account': 'Vytváření účtu',
        'Dismiss alert': 'Zavřít varování',
        Email: 'Email',
        'Enter your Birthdate': 'Datum narození',
        'Enter your code': 'Zadej svůj kód',
        'Enter your Confirmation Code': 'Zadej potvrzovací kód',
        'Enter your Email': 'Zadejte emailovou adresu',
        'Enter your Family Name': 'Zadejte rodné příjmení',
        'Enter your Given Name': 'Zadejte příjmení',
        'Enter your Middle Name': 'Zadejte prostřední jméno',
        'Enter your Name': 'Zadejte křestní jméno',
        'Enter your Nickname': 'Zadejte přezdívku',
        'Enter your Password': 'Zadejte heslo',
        'Enter your phone number': 'Zadejte telefonní číslo',
        'Enter your Preferred Username': 'Zadejte uživatelské jméno k zobrazení',
        'Enter your username': 'Zadejte uživatelské jméno',
        'Forgot password?': 'Zapomenuté heslo?',
        'Forgot your password?': 'Zapomenuté heslo?',
        'Hide password': 'Skrýt heslo',
        'It may take a minute to arrive': 'Může chvilku trvat než přijde',
        'Loading': 'Načítám',
        'New password': 'Nové heslo',
        'Nickname': 'Přezdívka',
        'or': 'nebo',
        'Password': 'Heslo',
        'Phone Number': 'Telefonní číslo',
        'Please confirm your Password': 'Potvrďte heslo',
        'Resend Code': 'Znovu odeslat kód',
        'Reset your password': 'Reset hesla',
        'Reset your Password': 'Reset hesla',
        'Send code': 'Odeslat kód',
        'Send Code': 'Odeslat kód',
        'Sending': 'Odesílám',
        'Setup TOTP': 'Nastavit TOTP',
        'Show password': 'Zobrazit heslo',
        'Sign in to your account': 'Přihlašte se k účtu',
        'Sign In with Amazon': 'Přihlásit se s Amazon',
        'Sign In with Apple': 'Přihlásit se s Apple',
        'Sign In with Facebook': 'Přihlásit se s Facebook',
        'Sign In with Google': 'Přihlásit se s Google',
        'Sign in': 'Přihlásit se',
        'Sign In': 'Přihlásit se',
        'Sign Up': "Vytvořit účet",
        'Signing in': 'Přihlašování',
        'Skip': 'Přeskočit',
        'Submit': 'Potvrdit',
        'Submitting': 'Potvrzuji',
        'Username': 'Uživatelské jméno',
        'Verify Contact': 'Potvrďte kontakt',
        'Verify': 'Potvrdit',
        'We Emailed You': 'Odeslali jsme Vám email',
        'We Sent A Code': 'Odeslali jsme Vám kód',
        'We Texted You': 'Odeslali jsme Vám SMS',
        'Your code is on the way. To log in, enter the code we emailed to': 'Vás kód je na cestě. Pro přihlášení, vložte kód který jste obdrželi emailem',
        'Your code is on the way. To log in, enter the code we sent you': 'Váš kód je na cestě. Pro přihlášení, vložte kód který jsme Vám poslali',
        'Your code is on the way. To log in, enter the code we texted to': 'Váš kód je na cestě. Pro přihlášení, vlož kód který jste obdrželi v SMS',
        'If you don\'t see the email, please check your spam or junk folder.': 'Pokud email nevidíte, zkontrolujte prosím složku spam nebo nevyžádaná pošta.',
    },
    es: {
        'Account recovery requires verified contact information': 'La recuperación de cuenta requiere información de contacto verificada',
        'Add your Profile': 'Añade tu Perfil',
        'Add your Website': 'Añade tu Sitio Web',
        'Back to Sign In': 'Volver a Iniciar Sesión',
        'Change Password': 'Cambiar Contraseña',
        Changing: 'Cambiando',
        Code: 'Código',
        'Confirm Password': 'Confirmar Contraseña',
        'Confirm Sign Up': 'Confirmar Registro',
        'Confirm SMS Code': 'Confirmar Código SMS',
        'Confirm MFA Code': 'Confirmar Código MFA',
        'Confirm TOTP Code': 'Confirmar Código TOTP',
        Confirm: 'Confirmar',
        'Confirmation Code': 'Código de Confirmación',
        Confirming: 'Confirmando',
        'Create a new account': 'Crear una nueva cuenta',
        'Create Account': 'Crear Cuenta',
        'Creating Account': 'Creando Cuenta',
        'Dismiss alert': 'Descartar alerta',
        Email: 'Correo Electrónico',
        'Enter your Birthdate': 'Fecha de Nacimiento',
        'Enter your code': 'Ingresa tu código',
        'Enter your Confirmation Code': 'Ingresa tu código de confirmación',
        'Enter your Email': 'Ingresa tu correo electrónico',
        'Enter your Family Name': 'Ingresa tu apellido',
        'Enter your Given Name': 'Ingresa tu nombre',
        'Enter your Middle Name': 'Ingresa tu segundo nombre',
        'Enter your Name': 'Ingresa tu nombre',
        'Enter your Nickname': 'Ingresa tu apodo',
        'Enter your Password': 'Ingresa tu contraseña',
        'Enter your phone number': 'Ingresa tu número de teléfono',
        'Enter your Preferred Username': 'Ingresa tu nombre de usuario preferido',
        'Enter your username': 'Ingresa tu nombre de usuario',
        'Forgot password?': '¿Olvidaste tu contraseña?',
        'Forgot your password?': '¿Olvidaste tu contraseña?',
        'Hide password': 'Ocultar contraseña',
        'It may take a minute to arrive': 'Puede tardar un minuto en llegar',
        'Loading': 'Cargando',
        'New password': 'Nueva contraseña',
        'Nickname': 'Apodo',
        'or': 'o',
        'Password': 'Contraseña',
        'Phone Number': 'Número de Teléfono',
        'Please confirm your Password': 'Por favor confirma tu contraseña',
        'Resend Code': 'Reenviar Código',
        'Reset your password': 'Restablecer tu contraseña',
        'Reset your Password': 'Restablecer tu Contraseña',
        'Send code': 'Enviar código',
        'Send Code': 'Enviar Código',
        'Sending': 'Enviando',
        'Setup TOTP': 'Configurar TOTP',
        'Show password': 'Mostrar contraseña',
        'Sign in to your account': 'Inicia sesión en tu cuenta',
        'Sign In with Amazon': 'Iniciar Sesión con Amazon',
        'Sign In with Apple': 'Iniciar Sesión con Apple',
        'Sign In with Facebook': 'Iniciar Sesión con Facebook',
        'Sign In with Google': 'Iniciar Sesión con Google',
        'Sign in': 'Iniciar sesión',
        'Sign In': 'Iniciar Sesión',
        'Sign Up': 'Crear Cuenta',
        'Signing in': 'Iniciando sesión',
        'Skip': 'Omitir',
        'Submit': 'Enviar',
        'Submitting': 'Enviando',
        'Username': 'Nombre de Usuario',
        'Verify Contact': 'Verificar Contacto',
        'Verify': 'Verificar',
        'We Emailed You': 'Te Enviamos un Correo',
        'We Sent A Code': 'Te Enviamos un Código',
        'We Texted You': 'Te Enviamos un SMS',
        'Your code is on the way. To log in, enter the code we emailed to': 'Tu código está en camino. Para iniciar sesión, ingresa el código que te enviamos por correo a',
        'Your code is on the way. To log in, enter the code we sent you': 'Tu código está en camino. Para iniciar sesión, ingresa el código que te enviamos',
        'Your code is on the way. To log in, enter the code we texted to': 'Tu código está en camino. Para iniciar sesión, ingresa el código que te enviamos por SMS a',
        'If you don\'t see the email, please check your spam or junk folder.': 'Si no ves el correo, por favor revisa tu carpeta de spam o correo no deseado.',
    },
    // Note: French, German, Portuguese, Japanese, Korean, and Chinese are supported by Amplify UI by default
    // Adding key translations for Arabic, Hindi, and Bengali which are not in default Amplify UI
    ar: {
        'Sign In': 'تسجيل الدخول',
        'Sign Up': 'إنشاء حساب',
        'Sign in': 'تسجيل الدخول',
        'Sign Out': 'تسجيل الخروج',
        'Create Account': 'إنشاء حساب',
        'Confirm Sign Up': 'تأكيد التسجيل',
        'Confirmation Code': 'رمز التأكيد',
        'Resend Code': 'إعادة إرسال الرمز',
        'Forgot password?': 'نسيت كلمة المرور؟',
        'Password': 'كلمة المرور',
        'Email': 'البريد الإلكتروني',
        'Username': 'اسم المستخدم',
        'Submit': 'إرسال',
        'Cancel': 'إلغاء',
        'Verify': 'تحقق',
        'Loading': 'جارٍ التحميل...',
    },
    hi: {
        'Sign In': 'साइन इन करें',
        'Sign Up': 'साइन अप करें',
        'Sign in': 'साइन इन करें',
        'Sign Out': 'साइन आउट करें',
        'Create Account': 'खाता बनाएं',
        'Confirm Sign Up': 'साइन अप की पुष्टि करें',
        'Confirmation Code': 'पुष्टिकरण कोड',
        'Resend Code': 'कोड पुनः भेजें',
        'Forgot password?': 'पासवर्ड भूल गए?',
        'Password': 'पासवर्ड',
        'Email': 'ईमेल',
        'Username': 'उपयोगकर्ता नाम',
        'Submit': 'सबमिट करें',
        'Cancel': 'रद्द करें',
        'Verify': 'सत्यापित करें',
        'Loading': 'लोड हो रहा है...',
    },
    bn: {
        'Sign In': 'সাইন ইন করুন',
        'Sign Up': 'সাইন আপ করুন',
        'Sign in': 'সাইন ইন করুন',
        'Sign Out': 'সাইন আউট করুন',
        'Create Account': 'অ্যাকাউন্ট তৈরি করুন',
        'Confirm Sign Up': 'সাইন আপ নিশ্চিত করুন',
        'Confirmation Code': 'নিশ্চিতকরণ কোড',
        'Resend Code': 'কোড পুনরায় পাঠান',
        'Forgot password?': 'পাসওয়ার্ড ভুলে গেছেন?',
        'Password': 'পাসওয়ার্ড',
        'Email': 'ইমেইল',
        'Username': 'ব্যবহারকারীর নাম',
        'Submit': 'জমা দিন',
        'Cancel': 'বাতিল করুন',
        'Verify': 'যাচাই করুন',
        'Loading': 'লোড হচ্ছে...',
    },
    // Note: Polish is supported by Amplify UI by default
    // Adding key translations for consistency
    pl: {
        'Sign In': 'Zaloguj się',
        'Sign Up': 'Zarejestruj się',
        'Sign in': 'Zaloguj się',
        'Sign Out': 'Wyloguj się',
        'Create Account': 'Utwórz konto',
        'Confirm Sign Up': 'Potwierdź rejestrację',
        'Confirmation Code': 'Kod potwierdzający',
        'Resend Code': 'Wyślij kod ponownie',
        'Forgot password?': 'Zapomniałeś hasła?',
        'Password': 'Hasło',
        'Email': 'E-mail',
        'Username': 'Nazwa użytkownika',
        'Submit': 'Prześlij',
        'Cancel': 'Anuluj',
        'Verify': 'Zweryfikuj',
        'Loading': 'Ładowanie...',
    }
});